export type result<R = any> = [any, R] // [error, result]

export interface TaskResponse<R = any> {
  code: number
  result: result<R>
  token: string | null
  // set only when NO server response arrived (fetch threw: network error /
  // timeout) — lets callers distinguish server-responded errors (CW2-648 §7.2)
  isNetworkError?: boolean
}

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}
